module.exports = __webpack_public_path__ + "static/img/newper.9c62da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newper.png
// module id = bzoN
// module chunks = 1